import _objectWithoutProperties from "/home/gitlab-runner/builds/FBhC8C3B/0/komelyanenko/qr-multilang-landing/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/home/gitlab-runner/builds/FBhC8C3B/0/komelyanenko/qr-multilang-landing/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/gitlab-runner/builds/FBhC8C3B/0/komelyanenko/qr-multilang-landing/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/gitlab-runner/builds/FBhC8C3B/0/komelyanenko/qr-multilang-landing/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectDestructuringEmpty from "/home/gitlab-runner/builds/FBhC8C3B/0/komelyanenko/qr-multilang-landing/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
var _excluded = ["gridSize", "method"];
import _regeneratorRuntime from "/home/gitlab-runner/builds/FBhC8C3B/0/komelyanenko/qr-multilang-landing/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import a, { createContext as h, useLayoutEffect as E, useEffect as w, useContext as M, useState as f, useMemo as C } from "react";
import x from "react-dom";
var Y = h({}),
  D = typeof document < "u" ? E : w;
function n(t, s) {
  var o;
  var l = function l(_ref, p) {
    var e = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    var _M = M(Y),
      r = _M.reactify,
      i = _M.ymaps,
      _f = f(!1),
      _f2 = _slicedToArray(_f, 2),
      d = _f2[0],
      u = _f2[1];
    return D(function () {
      s ? window[s] ? (u(!0), o = r.module(window[s])[t]) : i.import(s).then(function (m) {
        window[s] = m, r.module(m) && (u(!0), o = r.module(m)[t]);
      }) : (o = r.module(i)[t], u(!0));
    }, []), !o || !d ? null : /* @__PURE__ */a.createElement(o, _objectSpread({
      ref: p
    }, e));
  };
  return a.forwardRef(l);
}
var H = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
      var s,
        _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            s = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : "ru_RU";
            return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(o, l) {
                var e, r, _e;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!window.ymaps3) {
                        _context2.next = 10;
                        break;
                      }
                      e = window.ymaps3;
                      _context2.next = 4;
                      return e.ready;
                    case 4:
                      _context2.next = 6;
                      return e.import("@yandex/ymaps3-reactify");
                    case 6:
                      r = _context2.sent.reactify.bindTo(a, x);
                      r.module(e), o({
                        ymaps: e,
                        reactify: r
                      });
                      _context2.next = 12;
                      break;
                    case 10:
                      _e = document.createElement("script");
                      document.body.appendChild(_e), _e.type = "text/javascript", _e.src = "https://api-maps.yandex.ru/v3/?apikey=".concat(t, "&lang=").concat(s), _e.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                        var p, i;
                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                              p = window.ymaps3;
                              _context.next = 3;
                              return p.ready;
                            case 3:
                              _context.next = 5;
                              return p.import("@yandex/ymaps3-reactify");
                            case 5:
                              i = _context.sent.reactify.bindTo(a, x);
                              o({
                                ymaps: p,
                                reactify: i
                              });
                            case 7:
                            case "end":
                              return _context.stop();
                          }
                        }, _callee);
                      })), _e.onerror = l;
                    case 12:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function (_x2, _x3) {
                return _ref3.apply(this, arguments);
              };
            }()));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function H(_x) {
      return _ref2.apply(this, arguments);
    };
  }(),
  L = function L(_ref5) {
    var t = _ref5.apiKey,
      s = _ref5.lang,
      o = _ref5.children,
      l = _ref5.onLoad;
    var _f3 = f(),
      _f4 = _slicedToArray(_f3, 2),
      e = _f4[0],
      p = _f4[1];
    return D(function () {
      H(t, s).then(function (r) {
        p(r), l && l(r);
      });
    }, []), e ? /* @__PURE__ */a.createElement(Y.Provider, {
      value: e
    }, o) : /* @__PURE__ */a.createElement(a.Fragment, null);
  },
  T = a.memo(L);
var c = /* @__PURE__ */function (t) {
  return t.CartesianProjection = "@yandex/ymaps3-cartesian-projection@0.0.1", t.Clusterer = "@yandex/ymaps3-clusterer@0.0.1", t.Controls = "@yandex/ymaps3-controls@0.0.1", t.Hint = "@yandex/ymaps3-hint@0.0.1", t.Markers = "@yandex/ymaps3-markers@0.0.1", t.SphericalMercatorProjection = "@yandex/ymaps3-spherical-mercator-projection@0.0.1", t;
}(c || {});
var S = h({
    hint: void 0
  }),
  v = function v(_ref6) {
    var t = _ref6.children,
      s = _ref6.context;
    var o = M(s);
    return /* @__PURE__ */a.createElement(S.Provider, {
      value: o
    }, t);
  },
  j = function j(_ref7) {
    var t = _ref7.children,
      s = _ref7.hint;
    var _M2 = M(Y),
      o = _M2.reactify,
      l = _M2.ymaps,
      _f5 = f(),
      _f6 = _slicedToArray(_f5, 2),
      e = _f6[0],
      p = _f6[1],
      r = C(function () {
        if (e) {
          var i = window[c.Hint];
          return o.module(i).YMapHint;
        }
      }, [e]);
    return w(function () {
      if (window[c.Hint]) {
        var i = window[c.Hint];
        p(o.module(i).YMapHintContext);
      } else l.import(c.Hint).then(function (i) {
        window[c.Hint] = i, o.module(i) && p(o.module(i).YMapHintContext);
      });
    }, []), !r || !e || !t ? /* @__PURE__ */a.createElement(a.Fragment, null) : /* @__PURE__ */a.createElement(r, {
      hint: s
    }, /* @__PURE__ */a.createElement(v, {
      context: e
    }, t));
  },
  b = a.forwardRef(function (_ref8, l) {
    var t = _ref8.gridSize,
      s = _ref8.method,
      o = _objectWithoutProperties(_ref8, _excluded);
    var _M3 = M(Y),
      e = _M3.reactify,
      p = _M3.ymaps,
      _f7 = f(),
      _f8 = _slicedToArray(_f7, 2),
      r = _f8[0],
      i = _f8[1],
      _C = C(function () {
        if (r) {
          var y = window[c.Clusterer];
          return [e.module(y).YMapClusterer, s || e.module(y).clusterByGrid];
        }
        return [];
      }, [r]),
      _C2 = _slicedToArray(_C, 2),
      d = _C2[0],
      u = _C2[1];
    w(function () {
      window[c.Clusterer] ? i(window[c.Clusterer]) : p.import(c.Clusterer).then(function (y) {
        window[c.Clusterer] = y, i(y);
      });
    }, []);
    var m = C(function () {
      if (u && t) return u({
        gridSize: t
      });
    }, [u, t]);
    return !d || !m ? /* @__PURE__ */a.createElement(a.Fragment, null) : /* @__PURE__ */a.createElement(d, _objectSpread({
      ref: l,
      method: m
    }, o));
  }),
  B = n("YMapGeolocationControl", c.Controls),
  G = n("YMapZoomControl", c.Controls),
  $ = n("YMapClusterer", c.Clusterer),
  I = n("YMapDefaultMarker", c.Markers),
  W = n("YMap"),
  Z = n("YMapTileDataSource"),
  O = n("ThemeContext"),
  U = n("YMapControl"),
  _ = n("YMapLayer"),
  q = n("YMapMarker"),
  A = n("YMapDefaultSchemeLayer"),
  J = n("YMapDefaultFeaturesLayer"),
  K = n("YMapDefaultSatelliteLayer"),
  Q = n("YMapListener"),
  V = n("YMapControls"),
  X = n("YMapControlButton"),
  k = n("YMapContainer"),
  z = n("YMapCollection"),
  P = n("YMapFeature"),
  N = n("YMapFeatureDataSource");
export { O as ThemeContext, W as YMap, $ as YMapClusterer, z as YMapCollection, T as YMapComponentsProvider, k as YMapContainer, U as YMapControl, X as YMapControlButton, V as YMapControls, b as YMapCustomClusterer, J as YMapDefaultFeaturesLayer, I as YMapDefaultMarker, K as YMapDefaultSatelliteLayer, A as YMapDefaultSchemeLayer, P as YMapFeature, N as YMapFeatureDataSource, B as YMapGeolocationControl, j as YMapHint, S as YMapHintContext, _ as YMapLayer, Q as YMapListener, q as YMapMarker, Z as YMapTileDataSource, G as YMapZoomControl };